import { css } from 'lit';
export const selectOptionStyles = css `
    .hlx-select-option {
        width: 100%;
        cursor: pointer;
        padding: calc(var(--hlx-spacing-md) - 2px);
        border-radius: var(--hlx-radius-xs);
        border: 2px solid var(--hlx-background-color-default);
        box-sizing: border-box;
        min-height: 60px;
        background: var(--hlx-background-color-default);
        gap: var(--hlx-spacing-xs);
        color: var(--hlx-text-color-weak-1);
        font-weight: var(--hlx-text-font-weight-normal);
        font-family: var(--hlx-text-font-family-sans-serif);
        font-size: var(--hlx-text-font-size-md);
        display: flex;
        flex-shrink: 0;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .hlx-select-option:hover {
        background: var(--hlx-background-color-strong-2);
        border-color: var(--hlx-background-color-strong-2);
    }

    .hlx-select-option:focus {
        border-color: var(--hlx-color-brand-default);
        outline: none;
    }
    .hlx-select-option:active {
        outline: none;
    }

    .hlx-select-option-selected {
        font-weight: var(--hlx-text-font-weight-medium);
    }

    .hlx-select-option-icon {
        height: 16px;
        color: var(--hlx-color-success-default);
    }

    .hlx-select-option-content {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /* only apply if has children, otherwise flex interferes with text-overflow: ellipsis in the select */
    .hlx-select-option-content:has(> *) {
        display: flex;
        flex-direction: row;
        gap: var(--hlx-spacing-xs);
        align-items: center;
    }
`;
//# sourceMappingURL=select-option.styles.js.map